import css from "styled-jsx/css";
import colors from "styles/colors";
import { LAYER_ONE } from "constants/z-index";

import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MAX_WIDTH, XXS } from "constants/vp-sizes";

export default css`
  .one-pager-with-image-content-component {
    width: 100vw;
    display: flex;
    justify-content: space-around;

    .desktop-content-wrapper {
      width: 100%;
    }

    .mobile-content-wrapper {
      display: none;
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .one-pager-with-image-content-component {
      .desktop-content-wrapper {
        display: none;
      }

      .mobile-content-wrapper {
        display: flex;
        z-index: ${LAYER_ONE};
        justify-content: center;
        align-items: center;
      }
    }
  }
`;
